import { makeRequest } from 'utils/requestLogger';

export default (live_discussion_id) =>
  makeRequest(
    'put',
    `/api/live_discussions/${live_discussion_id}/toggle_queue`
  );



// WEBPACK FOOTER //
// ./src/app/services/liveDiscussion/toggleQueue.js